import "core-js/modules/es.array.concat";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.string.pad-start";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
import _ from 'lodash';
import moment from 'moment';
import sleep from 'sleep-promise';
import DatePicker from 'vuejs-datepicker';
import { ja } from 'vuejs-datepicker/dist/locale';
export default {
  data: function data() {
    return {
      ready: false,
      date: null
    };
  },
  components: {
    DatePicker: DatePicker
  },
  computed: {
    language: function language() {
      return ja;
    }
  },
  watch: {
    date: function date(val) {
      this.setAform(val);
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.ready = true;

              _this.$nextTick(function () {
                return _this.getDate();
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    setAform: function setAform(date) {
      var selects = this.$refs.aform.querySelectorAll('select');

      if (moment(date).isValid()) {
        selects[0].value = moment(date).format('YYYY');
        selects[1].value = moment(date).format('M');
        selects[2].value = moment(date).format('D');
      }
    },
    getDate: function getDate() {
      var _this2 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var selects, yyyy, mm, dd;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return sleep(200);

              case 2:
                selects = _this2.$refs.aform.querySelectorAll('select');
                yyyy = selects[0].value;
                mm = selects[1].value;
                dd = selects[2].value;
                if (mm) mm = _.padStart(mm, 2, '00');
                if (dd) dd = _.padStart(dd, 2, '00');

                if (moment("".concat(yyyy, "-").concat(mm, "-").concat(dd)).isValid()) {
                  _this2.date = "".concat(yyyy, "-").concat(mm, "-").concat(dd);
                }

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};